// RECARGAR LA PÁGINA EN UN PUNTO DE LA DOCUMENTACIÓN
// Al recargar, la página se pintaba arriba del todo y medio segundo después
// wikiMenu / ContentDoc saltaban a la sección del # de la URL (que además no es
// el punto exacto en el que se estaba). Aquí se guarda la posición de scroll de
// cada URL y, si la página se ha recargado, se vuelve a ella en cuanto las
// secciones están en el DOM, antes de que el navegador las pinte.
// Lo usan BaseLayout (guardar) y wikiMenu / ContentDoc (restaurar).

const storageKey = (): string => `docsScroll:${window.location.pathname}${window.location.hash}`;

const RESTORE_TIME = 3000;
const USER_EVENTS = ['wheel', 'touchstart', 'keydown', 'mousedown'];

const readSaved = (): number | null => {
  try {
    const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
    if (!nav || nav.type !== 'reload') return null;
    const value = sessionStorage.getItem(storageKey());
    return value === null ? null : Number(value);
  } catch (e) {
    return null;
  }
};

// Se lee una sola vez, al cargar la página: las navegaciones dentro de la SPA no restauran
let target: number | null = readSaved();
let started = false;

// Si la página recargada no tiene secciones (p. ej. la portada /default) nadie
// llama a restoreScroll: se descarta para no bloquear los saltos al # posteriores
if (target !== null) {
  window.setTimeout(() => { if (!started) target = null; }, 5000);
}

// true mientras se restaura: los efectos que hacen scroll al # de la URL no deben moverse
export const isRestoringScroll = (): boolean => target !== null;

// Se llama cuando las secciones ya están en el DOM (useLayoutEffect de wikiMenu / ContentDoc)
export const restoreScroll = (): void => {
  if (target === null || started) return;
  started = true;

  const apply = () => { if (target !== null) window.scrollTo(0, target); };
  apply();

  // Los .md y las imágenes llegan después y cambian el alto de la página: se
  // vuelve a colocar hasta que el usuario hace algo o pasan 3 segundos
  const RO = (window as any).ResizeObserver;
  const column = document.querySelector('.contentMarginX');
  const observer = RO && column ? new RO(apply) : null;
  if (observer) observer.observe(column);

  const stop = () => {
    target = null;
    if (observer) observer.disconnect();
    window.clearTimeout(timer);
    USER_EVENTS.forEach((type) => window.removeEventListener(type, stop, true));
  };
  const timer = window.setTimeout(stop, RESTORE_TIME);
  USER_EVENTS.forEach((type) => window.addEventListener(type, stop, true));
};

// Guarda la posición de la URL actual (BaseLayout, al hacer scroll y al salir)
export const saveScrollPosition = (): void => {
  if (target !== null) return; // mientras se restaura, la posición aún no es la buena
  try {
    sessionStorage.setItem(storageKey(), String(Math.round(window.scrollY)));
  } catch (e) {
    // sin sessionStorage (modo privado estricto): simplemente no se restaura
  }
};
